import { useMemo, useState } from "react";

interface Props extends React.ComponentProps<"div"> {
  activateTab?: any;
  data?: DataElement[];
}

export interface DataElement {
  label: string;
  content?: React.ReactNode | string;
  isDisabled?: boolean;
  onClick?: () => void;
}

const styles = `
  .tabs__frame {
    padding-top: 6px;
    display: flex; flex-direction: column; width: 100%;
    justify-content: start; justify-items: center;
  }
  .tabs__buttons_container {
    display: flex; flex-direction: row; width: 100%;
    justify-content: start; justify-items: center; overflow: auto;
  }
  button {
    all: unset;
    appearance: none;
    border: none;
    background: none;
    box-shadow: none;
    margin: 0;
    padding: 0;
    font: inherit;
    color: inherit;
    line-height: normal;
    cursor: pointer;
    font-size: 16px;
  }
  .tab_button { 
    background: white;
    padding: 10px 20px;
    color: lightgrey;
  }
  .tab_button__active { 
    background: white;
    padding: 10px 20px;
    color: black;
  }
  .tab_button:hover { 
    background-color: #f5f5f5;
  }
`;

export const Tabs: React.FC<Props> = ({ activateTab, data }) => {
  const [activeTab, SetActiveTab] = useState(
    data?.findIndex((element: DataElement) => element.isDisabled !== true) ?? 0,
  );
  const tabContent = useMemo(
    () => data && data[activeTab]?.content,
    [data, activeTab],
  );
  const handleTab = (i: number) => {
    if (!data) {
      return null;
    }
    const tabAction = data[i].onClick;
    if (tabAction) {
      tabAction();
    }
    activateTab(i);
    SetActiveTab(i);
  };

  return (
    <>
      <style>{styles}</style>
      <div className="tabs__frame">
        <div className="tabs__buttons_container">
          {data?.map(({ label, isDisabled }, index) => (
            <button
              className={
                activeTab === index ? "tab_button__active" : "tab_button"
              }
              key={`tab-${index}-${label}`}
              onClick={() => handleTab(index)}
              disabled={isDisabled}
            >
              {label}
            </button>
          ))}
        </div>
        {tabContent && (
          <div className="w-full">
            {typeof tabContent === "string" ? <p>{tabContent}</p> : tabContent}
          </div>
        )}
      </div>
    </>
  );
};
